import React from "react";
import styles from "./FaqCard.module.css";
import { SimilarKnowledge } from "../../api/responsePayload/KnowledgeResponse";
import CustomButton, { ButtonType } from "../button/CustomButton";

interface FaqCardProps {
  index: number;
  faq: SimilarKnowledge;
  onDelete: (id: number) => void;
}

const FaqCard: React.FC<FaqCardProps> = ({ index, faq, onDelete }) => {
  const { question, answer, heading, content } = extract(faq.retrieve_content);

  return (
    <div className={styles.card}>
      <div>{index}</div>
      <div className={styles.qa}>
        {question && <div style={{ fontWeight: 600 }}>{question}</div>}
        {answer && <div>{answer}</div>}
        {heading && <div style={{ fontWeight: 600 }}>{heading}</div>}
        {content && <div>{content}</div>}
      </div>
      <CustomButton
        type={ButtonType.Reject}
        onClick={() => onDelete(faq.knowledge_content_id)}
        text="Delete"
      />
    </div>
  );

  function extract(text: string) {
    const qaRegex =
      /question:\s*([\s\S]*?)(?=\s*answer:|$)\s*answer:\s*([\s\S]*?)$/i;
    const hcRegex = /heading:\s*([\s\S]*?)\s*content:\s*([\s\S]*)/i;

    const qaMatch = text.match(qaRegex);
    const hcMatch = text.match(hcRegex);

    const result = {
      question: "",
      answer: "",
      heading: "",
      content: "",
    };

    if (qaMatch) {
      const [, rawQuestion, rawAnswer] = qaMatch;
      result.question = rawQuestion.trim();
      result.answer = rawAnswer.trim();
    }

    if (hcMatch) {
      const [, rawHeading, rawContent] = hcMatch;
      result.heading = rawHeading.trim();
      result.content = rawContent.trim();
    }

    return result;
  }
};

export default FaqCard;
